import React from 'react';
import { IBaseDisbursementStatusPill } from '../IBaseDisbursementStatusPill';
import { assertValueIsOfType } from 'utilities/Assertions';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { eCheckVoidReason } from 'types/accounting/eCheckVoidReason';
import { BaseStatusPill } from '../shared/BaseStatusPill';

const getPillDetails = (check: ICheckDisbursementFormData) => {
  switch (true) {
    case check.voidReason === eCheckVoidReason.StaleAutoVoided:
      return 'Auto-Void';
    case !!check.voidedAt:
      return 'Void';
    case !!check.completedAt || !!check.completedAtDate:
      return 'Disbursed';
    case !!check.sentAt || !!check.sentAtDate:
      return 'Initiated';
    case !!check.holdback:
      return 'Holdback';
    case !!check.printedDate && !check.sentAtDate:
      return 'Printed';
    default:
      return 'Staged';
  }
};

export const CheckStatusPill: React.FC<IBaseDisbursementStatusPill> = ({ disbursement, amountMismatch }) => {
  assertValueIsOfType<ICheckDisbursementFormData>(
    disbursement,
    () => disbursement.type === 'Check',
    `I was supposed to only be passed a check and I was passed a ${disbursement.type} instead`
  );

  const status = getPillDetails(disbursement);
  return (
    <BaseStatusPill
      data-test-id={`check-status-pill-${disbursement.id}`}
      href={disbursement.trackingUrl}
      status={status}
      text={'Check'}
      amountCents={disbursement.amountCents}
      id={disbursement.id}
      title={disbursement.trackingUrl ? 'Visit Tracking URL' : undefined}
      hasWarning={amountMismatch}
    />
  );
};
